<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Rotation:</span>
    <div class="wf-w-1/2">
      <select v-model="iconRotation" class="wf-w-full">
        <option value="ICON_ROTATE_NONE">None</option>
        <option value="ICON_ROTATE_90">Rotate 90</option>
        <option value="ICON_ROTATE_180">Rotate 180</option>
        <option value="ICON_ROTATE_270">Rotate 270</option>
        <option value="ICON_ROTATE_HORIZONTAL">Flip Horizontal</option>
        <option value="ICON_ROTATE_VERTICAL">Flip Vertical</option>
        <option value="ICON_ROTATE_BOTH">Flip Both</option>
      </select>
    </div>
  </li>
</template>

<script>
  import _ from "lodash";
  import { IconRotatedClasses } from '../classes/IconRotatedClasses'
  import MenuStyleProperty from "../contracts/MenuStyleProperty";
  export default MenuStyleProperty.extend({
    computed: {
      iconRotationClasses() {
        return Object.keys(IconRotatedClasses)
      },
      iconRotation: {
        get() {
          let currentIconRotation = this.elementClasses(this.classes)[this.device].find(elementClass => this.iconRotationClasses.includes(elementClass.value))
          if (!currentIconRotation) {
            currentIconRotation = {property: 'IconRotated', value: 'ICON_ROTATE_NONE', touched: false}
            this.addToArray(this.module, [currentIconRotation], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentIconRotation.value
        },
        set: _.debounce(function (value) {
          let currentIconRotation = this.elementClasses(this.classes)[this.device].find(elementClass => this.iconRotationClasses.includes(elementClass.value))
          value = {property: 'IconRotated', value: value, touched: currentIconRotation.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>
